import { Directive, HostListener, ElementRef, Input } from '@angular/core';
@Directive({
  selector: '[appIpecialIsAlphaNumeric]'
})
export class SpecialCharacterDirective {

  regexStr = /^(?!,$)[\d,.$]+$/;

  @Input() isAlphaNumeric: boolean;

  constructor(private el: ElementRef) { }


  @HostListener('keypress', ['$event']) onKeyPress(event) {
    return ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', ',', '.'].indexOf(event.key) !== -1;
  }

  @HostListener('paste', ['$event']) blockPaste(event: KeyboardEvent) {
    this.validateFields(event);
  }

  validateFields(event) {
    setTimeout(() => {
      this.el.nativeElement.value = this.el.nativeElement.value.replace(this.regexStr, '');
      event.preventDefault();
    }, 100);
  }

}
